<template>
  <v-app id="inspire" class="neon-app">

    <!-- Fondo animado: grid + orbes de luz -->
    <div class="neon-bg-layer" aria-hidden="true">
      <div class="neon-orb neon-orb--purple"></div>
      <div class="neon-orb neon-orb--cyan"></div>
      <div class="neon-orb neon-orb--pink"></div>
    </div>

    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="5" lg="4">

            <!-- Tarjeta principal -->
            <div class="neon-card-wrapper neon-fade-in">

              <!-- Header con logo de texto -->
              <div class="neon-login-header">
                <div class="neon-login-logo">
                  <v-icon class="neon-login-logo__icon">mdi-school-outline</v-icon>
                  <span class="neon-login-logo__text">{{ title }}</span>
                </div>
                <p class="neon-login-header__sub">Acceder al Sistema Administrativo</p>
              </div>

              <!-- Imagen del cliente -->
              <div class="neon-logo-img-wrapper">
                <v-img
                  src="img/logoscorps.webp"
                  vmax-width="220"
                  class="neon-logo-img"
                  contain
                />
              </div>

              <!-- Formulario -->
              <div class="neon-form-body">
                <v-form @submit.prevent="onLogin">

                  <div class="neon-field-wrapper">
                    <v-text-field
                      label="Usuario"
                      v-model="usuario"
                      name="login"
                      prepend-inner-icon="mdi-account-outline"
                      type="text"
                      outlined 
                      dark
                      class="neon-input"
                      autocomplete="username"
                    />
                  </div>

                  <div class="neon-field-wrapper">
                    <v-text-field
                      id="password"
                      label="Contraseña"
                      name="password"
                      v-model="clave"
                      prepend-inner-icon="mdi-lock-outline"
                      :append-icon="value ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                      @click:append="() => (value = !value)"
                      v-on:keyup.enter="onLogin"
                      :type="value ? 'password' : 'text'"
                      outlined 
                      dark
                      class="neon-input"
                      autocomplete="current-password"
                    />
                  </div>

                  <!-- Botón de ingreso -->
                  <button
                    class="neon-login-btn"
                    :class="{ 'neon-login-btn--loading': loading }"
                    @click.prevent="onLogin"
                    :disabled="loading"
                    type="submit"
                  >
                    <span v-if="!loading" class="neon-login-btn__content">
                      <v-icon dark small class="neon-login-btn__icon">mdi-account-key</v-icon>
                      Ingresar
                    </span>
                    <span v-else class="neon-login-btn__content">
                      <v-progress-circular indeterminate size="18" width="2" color="white" class="mr-2" />
                      Validando...
                    </span>
                  </button>

                </v-form>
              </div>

              <!-- Alerta de estado -->
              <div
                class="neon-alert"
                :class="{
                  'neon-alert--error':   msg.includes('incorrectos') || msg.includes('conexion'),
                  'neon-alert--success': msg.includes('Ingresando'),
                  'neon-alert--loading': msg.includes('Validando'),
                }"
              >
                <v-icon small class="neon-alert__icon">
                  {{
                    msg.includes('Ingresando')  ? 'mdi-check-circle-outline' :
                    msg.includes('Validando')   ? 'mdi-loading mdi-spin'     :
                    msg.includes('incorrectos') || msg.includes('conexion') ? 'mdi-alert-circle-outline' :
                    'mdi-information-outline'
                  }}
                </v-icon>
                <span class="neon-alert__text">{{ msg }}</span>
              </div>

            </div>
            <!-- /neon-card-wrapper -->

          </v-col>
        </v-row>

        <!-- Debug oculto -->
        <small style="position:absolute;bottom:0;right:0;opacity:0"> {{ url }} </small>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import { setAccessToken, setUserData } from './accessToken';
  import gql from 'graphql-tag';
  export default {
    props: {
      source: String,
    },
    data() {
      return {
        value: String,
        loading: false,
        msg: 'Ingrese su usuario y clave para acceder al sistema',
        usuario: '',
        clave: '',
        // title: process.env.VUE_APP_NAME,
        title: "PORTAL ESAM",
        url: process.env.VUE_APP_AUTH,
      };
    },
    apollo: {
      $client: 'httpLinkAuth',
    },
    methods: {
      async addTag() {
        this.$apollo
          .mutate({
            mutation: gql`mutation{login(login: "${this.usuario}", clave: "${this.clave}")
          { accessToken }}`,
          })
          .then(({ data: { login } }) => {
            const accessToken = login.accessToken;
            window.console.log('TOKEN:::', login);
            if (accessToken == null || accessToken.length == 0) {
              this.msg = 'Datos incorrectos, ingrese su usuario y clave para acceder al sistema.';
              this.loading = false;
            } else {
              window.console.log(accessToken);
              setAccessToken(accessToken);
              setUserData(this.usuario, this.clave);
              this.$store.state.isLogin = true;
              this.msg = 'Ingresando...';
              window.location.reload(true);
            }
          })
          .catch((error) => {
            this.loading = false;
            window.console.error(error);
            this.msg = 'No se pudo establecer una conexion, intentelo nuevamente';
          });
      },
      onLogin(e = null) {
        if (e) e.preventDefault();
        if (this.usuario.trim().length == 0 && this.clave.trim().length == 0) return;
        this.msg = 'Validando datos...';
        this.loading = true;
        this.addTag();
      },
    },
    mounted() {
      window.localStorage.clear();
      window.sessionStorage.clear();
    },
  };
</script>

<style scoped>
/* ─────────────────────────────────────────────
   Fuentes (agregar también en index.html si no están)
   <link href="https://fonts.googleapis.com/css2?family=Exo+2:wght@700;800&family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet">
   ───────────────────────────────────────────── */

/* ═══════════════════════════════════════
   TOKENS LOCALES (misma paleta que clubes-neon.css)
   ═══════════════════════════════════════ */
.neon-app {
  --neon-bg-base:       #07070f;
  --neon-bg-surface:    #0f0f1e;
  --neon-bg-card:       #131327;
  --neon-bg-input:      #1c1c38;
  --neon-purple:        #a855f7;
  --neon-purple-light:  #c084fc;
  --neon-purple-dark:   #7c3aed;
  --neon-cyan:          #22d3ee;
  --neon-green:         #10b981;
  --neon-green-light:   #34d399;
  --neon-gold:          #f59e0b;
  --neon-pink:          #ec4899;
  --neon-pink-dark:     #be185d;
  --neon-border-card:   rgba(255, 255, 255, 0.09);
  --neon-border-glow:   rgba(168, 85, 247, 0.4);
  --neon-text-primary:  #f1f0ff;
  --neon-text-secondary:#a09dc0;
  --neon-text-muted:    #5c5a7a;
  --neon-grad-action:   linear-gradient(135deg, #be185d 0%, #ec4899 55%, #a855f7 100%);
  --neon-glow-purple:   0 0 30px rgba(168, 85, 247, 0.35);
  --neon-glow-card:     0 0 60px rgba(168, 85, 247, 0.12);
  --neon-transition:    all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ═══════════════════════════════════════
   APP — Fondo base
   ═══════════════════════════════════════ */
.neon-app {
  background-color: var(--neon-bg-base) !important;
  font-family: 'DM Sans', 'Nunito', sans-serif !important;
  position: relative;
  overflow: hidden;
}

/* ─── Capa de fondo: grid de puntos ─── */
.neon-app::before {
  content: '';
  position: fixed;
  inset: 0;
  background-image: radial-gradient(circle, rgba(168, 85, 247, 0.07) 1px, transparent 1px);
  background-size: 28px 28px;
  pointer-events: none;
  z-index: 0;
}

/* ─── Orbes de luz ambiental ─── */
.neon-bg-layer {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.neon-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.18;
  animation: neonOrbFloat 12s ease-in-out infinite alternate;
}

.neon-orb--purple {
  width: 480px;
  height: 480px;
  background: radial-gradient(circle, #a855f7, transparent 70%);
  top: -120px;
  left: -100px;
  animation-duration: 14s;
}

.neon-orb--cyan {
  width: 360px;
  height: 360px;
  background: radial-gradient(circle, #22d3ee, transparent 70%);
  bottom: -80px;
  right: -60px;
  animation-duration: 10s;
  animation-delay: -4s;
}

.neon-orb--pink {
  width: 280px;
  height: 280px;
  background: radial-gradient(circle, #ec4899, transparent 70%);
  top: 40%;
  right: 15%;
  animation-duration: 16s;
  animation-delay: -8s;
}

@keyframes neonOrbFloat {
  0%   { transform: translate(0, 0) scale(1); }
  50%  { transform: translate(30px, -20px) scale(1.08); }
  100% { transform: translate(-20px, 30px) scale(0.95); }
}

/* ═══════════════════════════════════════
   TARJETA PRINCIPAL
   ═══════════════════════════════════════ */
.neon-card-wrapper {
  position: relative;
  z-index: 1;
  background: var(--neon-bg-card);
  border-radius: 20px;
  border: 1px solid var(--neon-border-card);
  box-shadow:
    0 0 0 1px rgba(168, 85, 247, 0.12),
    0 8px 40px rgba(0, 0, 0, 0.7),
    var(--neon-glow-card);
  overflow: hidden;
}

/* Línea neon superior de acento */
.neon-card-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent 0%, var(--neon-purple) 30%, var(--neon-pink) 60%, var(--neon-cyan) 100%);
  border-radius: 20px 20px 0 0;
}

/* ═══════════════════════════════════════
   HEADER DE LA TARJETA
   ═══════════════════════════════════════ */
.neon-login-header {
  padding: 28px 28px 0;
  text-align: center;
}

.neon-login-logo {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.neon-login-logo__icon {
  font-size: 1.5rem !important;
  background: linear-gradient(135deg, var(--neon-pink), var(--neon-purple-light));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.neon-login-logo__text {
  font-family: 'Exo 2', 'Rajdhani', sans-serif;
  font-size: 1.45rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  background: linear-gradient(90deg, var(--neon-pink) 0%, var(--neon-purple-light) 50%, var(--neon-cyan) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-transform: uppercase;
}

.neon-login-header__sub {
  color: var(--neon-text-muted);
  font-size: 0.75rem;
  letter-spacing: 0.04em;
  margin: 4px 0 0;
}

/* ═══════════════════════════════════════
   IMAGEN LOGO EMPRESA
   ═══════════════════════════════════════ */
.neon-logo-img-wrapper {
  display: flex;
  justify-content: center;
  padding: 20px 28px 4px;
}

.neon-logo-img {
  border-radius: 10px;
  opacity: 0.9;
  filter: drop-shadow(0 0 12px rgba(168, 85, 247, 0.25));
}

/* ═══════════════════════════════════════
   CUERPO DEL FORMULARIO
   ═══════════════════════════════════════ */
.neon-form-body {
  padding: 16px 28px 4px;
}

.neon-field-wrapper {
  margin-bottom: 4px;
}

/* ─── Override Vuetify 2 inputs con ::v-deep ─── */

/* Fondo del campo */
.neon-form-body ::v-deep .neon-input .v-input__control .v-input__slot {
  background: var(--neon-bg-input) !important;
  border-radius: 10px !important;
}

/* Borde outlined en reposo */
.neon-form-body ::v-deep .neon-input.v-text-field--outlined fieldset {
  border-color: rgba(255, 255, 255, 0.12) !important;
  transition: var(--neon-transition);
}

/* Borde outlined en foco → neon purple */
.neon-form-body ::v-deep .neon-input.v-text-field--outlined.v-input--is-focused fieldset {
  border-color: var(--neon-purple) !important;
  box-shadow: 0 0 0 2px rgba(168, 85, 247, 0.18);
}

/* Label en reposo */
.neon-form-body ::v-deep .neon-input .v-label {
  color: var(--neon-text-muted) !important;
  font-size: 0.85rem;
}

/* Label en foco */
.neon-form-body ::v-deep .neon-input.v-input--is-focused .v-label {
  color: var(--neon-purple-light) !important;
}

/* Texto escrito */
.neon-form-body ::v-deep .neon-input input {
  color: var(--neon-text-primary) !important;
  caret-color: var(--neon-purple-light) !important;
  font-size: 0.9rem;
}

/* Ícono prepend */
.neon-form-body ::v-deep .neon-input .v-input__prepend-inner .v-icon {
  color: var(--neon-text-muted) !important;
  transition: var(--neon-transition);
}

.neon-form-body ::v-deep .neon-input.v-input--is-focused .v-input__prepend-inner .v-icon {
  color: var(--neon-purple-light) !important;
}

/* Ícono append (ojo contraseña) */
.neon-form-body ::v-deep .neon-input .v-input__append-inner .v-icon {
  color: var(--neon-text-muted) !important;
  transition: var(--neon-transition);
}

.neon-form-body ::v-deep .neon-input .v-input__append-inner .v-icon:hover {
  color: var(--neon-cyan) !important;
}

/* ═══════════════════════════════════════
   BOTÓN DE INGRESO
   ═══════════════════════════════════════ */
.neon-login-btn {
  width: 100%;
  padding: 13px 24px;
  margin-top: 8px;
  border: none;
  border-radius: 10px;
  background: var(--neon-grad-action);
  color: #fff;
  font-family: 'DM Sans', sans-serif;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(236, 72, 153, 0.4);
  transition: var(--neon-transition);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

/* Shimmer sweep al hover */
.neon-login-btn::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(120deg, transparent, rgba(255,255,255,0.15), transparent);
  transition: left 0.5s ease;
}

.neon-login-btn:hover:not(:disabled)::after { left: 150%; }

.neon-login-btn:hover:not(:disabled) {
  box-shadow: 0 6px 30px rgba(236, 72, 153, 0.6), 0 0 0 1px rgba(236, 72, 153, 0.4);
  transform: translateY(-1px);
  filter: brightness(1.08);
}

.neon-login-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(236, 72, 153, 0.4);
}

.neon-login-btn:disabled,
.neon-login-btn--loading {
  opacity: 0.7;
  cursor: not-allowed;
  pointer-events: none;
}

.neon-login-btn__content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.neon-login-btn__icon {
  font-size: 1rem !important;
}

/* ═══════════════════════════════════════
   ALERTA DE ESTADO
   ═══════════════════════════════════════ */
.neon-alert {
  margin: 20px 28px 24px;
  padding: 12px 16px;
  border-radius: 10px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1.5;
  border: 1px solid transparent;
  transition: var(--neon-transition);
  /* Estado por defecto: info */
  background: rgba(168, 85, 247, 0.08);
  border-color: rgba(168, 85, 247, 0.25);
  color: var(--neon-purple-light);
}

.neon-alert__icon {
  flex-shrink: 0;
  margin-top: 1px;
  font-size: 1rem !important;
  color: inherit !important;
}

.neon-alert__text { flex: 1; }

/* Variante error */
.neon-alert--error {
  background: rgba(239, 68, 68, 0.08) !important;
  border-color: rgba(239, 68, 68, 0.3) !important;
  color: #fca5a5 !important;
}

/* Variante éxito */
.neon-alert--success {
  background: rgba(16, 185, 129, 0.08) !important;
  border-color: rgba(16, 185, 129, 0.3) !important;
  color: var(--neon-green-light) !important;
}

/* Variante cargando */
.neon-alert--loading {
  background: rgba(245, 158, 11, 0.08) !important;
  border-color: rgba(245, 158, 11, 0.25) !important;
  color: #fcd34d !important;
}

/* ═══════════════════════════════════════
   ANIMACIÓN DE ENTRADA
   ═══════════════════════════════════════ */
@keyframes neonFadeInUp {
  from { opacity: 0; transform: translateY(24px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0)   scale(1); }
}

.neon-fade-in {
  animation: neonFadeInUp 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

/* ═══════════════════════════════════════
   OVERRIDE: Vuetify app background
   ═══════════════════════════════════════ */
.neon-app ::v-deep .v-application--wrap {
  background-color: transparent !important;
}

.neon-app ::v-deep .v-main {
  background-color: transparent !important;
}

/* Scrollbar */
.neon-app ::-webkit-scrollbar       { width: 5px; }
.neon-app ::-webkit-scrollbar-track { background: var(--neon-bg-base); }
.neon-app ::-webkit-scrollbar-thumb { background: rgba(168, 85, 247, 0.3); border-radius: 99px; }
</style>